export const CertificateGenerator = async (user, param) => {
    var today = new Date()
    var month = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"][today.getMonth()];
    var sDate = 'Curitiba, ' + today.getDate() + ' de ' + month + ' de ' + today.getFullYear() + '.'

    return (
'<!DOCTYPE html> ' +
'<html lang="pt-BR"> ' +
'<head> ' +
    '<meta charset="UTF-8"> ' +
    '<title>Certificado</title> ' +
    '<style> ' +
        '@page { ' +
            'size: A4 landscape; ' +
            'margin: 0; ' +
        '} ' +
        'body { ' +
            'margin: 0; ' +
            'padding: 0; ' +
            'background-color: #e2e8f0; ' +
            'font-family: Georgia, serif; ' +
            'display: flex; ' +
            'justify-content: center; ' +
            'align-items: center; ' +
            'height: 100vh; ' +
        '} ' +
        '.certificado-container { ' +
            'width: 100%; ' +
            'height: 100%; ' +
            'background-color: #ffffff; ' +
            'color: #0f172a; ' +
            'padding: 40px; ' +
            'position: relative; ' +
            'display: flex; ' +
            'flex-direction: column; ' +
            'justify-content: space-between; ' +
            'box-sizing: border-box; ' +
            'box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); ' +
            'border: 24px double rgba(139, 101, 8, 0.8); ' +
            'overflow: hidden; ' +
        '} ' +
        '.watermark { ' +
            'position: absolute; ' +
            'inset: 0; ' +
            'display: flex; ' +
            'align-items: center; ' +
            'justify-content: center; ' +
            'opacity: 0.03; ' +
            'pointer-events: none; ' +
        '} ' +
        '.header { ' +
            'position: relative; ' +
            'z-index: 10; ' +
            'display: flex; ' +
            'align-items: flex-start; ' +
            'justify-content: space-between; ' +
        '} ' +
        '.logo-left { ' +
            'width: 250px; ' +
            'flex-shrink: 0; ' +
            'display: flex; ' +
            'margin-top: -50px; ' +
            'margin-left: -50px; ' +
            'position: absolute; ' +
        '} ' +
        '.logo-left img { ' +
            'width: 250px; ' +
            'height: auto; ' +
            'object-fit: contain; ' +
        '} ' +
        '.header-text { ' +
            'text-align: center; ' +
            'flex: 1; ' +
        '} ' +
        '.header-text p.sub-1 { ' +
            'font-size: 11px; ' +
            'font-family: sans-serif; ' +
            'letter-spacing: 0.2em; ' +
            'font-weight: bold; ' +
            'color: #8b6508; ' +
            'margin: 0 0 4px 0; ' +
        '} ' +
        '.header-text p.sub-2 { ' +
            'font-size: 10px; ' +
            'font-family: sans-serif; ' +
            'letter-spacing: 0.15em; ' +
            'color: #475569; ' +
            'margin: 0 0 8px 0; ' +
        '} ' +
        '.header-text h2 { ' +
            'font-size: 60px; ' +
            'font-weight: bold; ' +
            'letter-spacing: 20px; ' +
            'color: #0f172a; ' +
            'margin: 90px 0 8px 0; ' +
            'text-transform: uppercase; ' +
            'font-family: emoji; ' +
            'transform: scaleY(2); ' +
        '} ' +
        '.separator-container { ' +
            'height: 50px; ' +
            'width: auto; ' +
            'align-items: flex-end; ' +
            'justify-content: center; ' +
            'margin-top: 30px; ' +
        '} ' +
        '.separator-container img { ' +
            'width: 500px; ' +
            'height: auto; ' +
        '} ' +
        '.body-content { ' +
            'margin-top: 20px; ' +
            'text-align: center; ' +
            'position: relative; ' +
            'z-index: 10; ' +
            'padding: 0 32px; ' +
        '} ' +
        '.body-content h3 { ' +
            'font-size: 30px; ' +
            'font-weight: bold; ' +
            'color: #0369a1; ' +
            'letter-spacing: 0.05em; ' +
            'margin: 0 0 4px 0; ' +
            'font-family: emoji; ' +
            'transform: scaleY(1.5); ' +
        '} ' +
        '.body-content p.details { ' +
            'font-size: 16px; ' +
            'font-family: sans-serif; ' +
            'color: #475569; ' +
            'margin: 0 0 16px 0; ' +
        '} ' +
        '.body-content p.legal-text { ' +
            'font-size: 16px; ' +
            'line-height: 1.6; ' +
            'color: #334155; ' +
            'text-align: center; ' +
            'padding: 0 16px; ' +
            'font-family: sans-serif; ' +
            'margin: 0; ' +
        '} ' +
        '.body-content p.crdd-text { ' +
            'font-size: 16px; ' +
            'line-height: 1.6; ' +
            'color: #334155; ' +
            'text-align: center; ' +
            'padding: 0 16px; ' +
            'font-family: sans-serif; ' +
            'margin: 0; ' +
        '} ' +
        '.city-date { ' +
            'text-align: center; ' +
            'color: #334155; ' +
            'font-size: 16px; ' +
            'font-family: sans-serif; ' +
        '} ' +
        '.footer { ' +
            'position: relative; ' +
            'z-index: 10; ' +
            'display: flex; ' +
            'justify-content: space-between; ' +
            'align-items: flex-end; ' +
            'font-size: 12px; ' +
            'font-family: sans-serif; ' +
        '} ' +
        '.signature-box { ' +
            'text-align: center; ' +
            'width: 256px; ' +
            'margin-top: -30px; ' +
        '} ' +
        '.signature-line-area { ' +
            'height: 40px; ' +
            'display: flex; ' +
            'align-items: flex-end; ' +
            'justify-content: center; ' +
            'margin-bottom: 4px; ' +
        '} ' +
        '.signature-line-area img { ' +
            'max-height: 48px; ' +
            'object-fit: contain; ' +
            'border-bottom: 1px solid #94a3b8; ' +
        '} ' +
        '.signature-box p.name { ' +
            'font-weight: bold; ' +
            'color: #0369a1; ' +
            'margin: 0; ' +
        '} ' +
        '.signature-box p.title { ' +
            'font-size: 10px; ' +
            'color: #a16207; ' +
            'margin: 0; ' +
        '} ' +
        '.signature-box p.sub { ' +
            'font-size: 9px; ' +
            'color: #94a3b8; ' +
            'letter-spacing: 0.05em; ' +
            'margin: 0; ' +
        '} ' +
        '.footer-logo-center { ' +
            'width: 120px; ' +
            'flex-shrink: 0; ' +
            'text-align: center; ' +
        '} ' +
        '.footer-logo-center img { ' +
            'width: 120px; ' +
            'height: auto; ' +
            'object-fit: contain; ' +
        '} ' +
    '</style> ' +
'</head> ' +
'<body> ' +
    '<div class="certificado-container"> ' +
        '<div class="header"> ' +
            '<div class="logo-left"> ' +
                '<img src="https://storage.googleapis.com/ticoop-br.appspot.com/crdd.png" alt="Logo CRDD-PR"> ' +
            '</div> ' +
            '<div class="header-text"> ' +
                '<h2>Certificado</h2> ' +
                '<div class="separator-container"> ' +
                    '<img src="https://storage.googleapis.com/ticoop-br.appspot.com/separator.png" alt="Separador"> ' +
                '</div> ' +
            '</div> ' +
        '</div> ' +
        '<div class="body-content"> ' +
            '<div> ' +
                '<h3>' + user.name + '</h3> ' +
                '<br><br> ' +
                '<p class="details">Filiação CRDD-PR n°' + user.crdd + ' | Rg. ' + user.docaux + ' — CPF: ' + user.document + '</p> ' +
            '</div> ' +
            '<p class="legal-text"> ' +
                'Certifica-se para os devidos fins e efeitos, nos termos do Inciso III do Art. 5° e do Art. 12° da Lei federal 14282 de 28 de dezembro de 2021, que o(a) <strong>PROFISSIONAL DESPACHANTE DOCUMENTALISTA</strong> acima qualificado, encontra-se devidamente inscrito(a) no Conselho Regional dos Despachantes Documentalistas do Estado do Paraná CRDD-PR. ' +
            '</p> ' +
            '<br> ' +
            '<p class="crdd-text"> ' +
                'Conselho Regional dos Despachantes Documentalistas do Estado do Paraná' + 
            '</p> ' +
        '</div> ' +
        '<div class="city-date"> ' +
            '<p>' + sDate + '</p> ' +
        '</div> ' +
        '<div class="footer"> ' +
            '<div class="signature-box"> ' +
                '<div class="signature-line-area"> ' +
                    '<img src="https://storage.googleapis.com/ticoop-br.appspot.com/assinatura01.png" alt="Assinatura Presidente"> ' +
                '</div> ' +
                '<p class="name">' + param.president + '</p> ' +
                '<p class="title">PRESIDENTE</p> ' +
                '<p class="sub">Junta Interventora</p> ' +
            '</div> ' +
            '<div class="footer-logo-center"> ' +
                '<img src="https://storage.googleapis.com/ticoop-br.appspot.com/crdd-2.png" alt="Logo CRDD-PR"> ' +
            '</div> ' +
            '<div class="signature-box"> ' +
                '<div class="signature-line-area"> ' +
                    '<img src="https://storage.googleapis.com/ticoop-br.appspot.com/assinatura02.png" alt="Assinatura Diretor"> ' +
                '</div> ' +
                '<p class="name">' + param.director + '</p> ' +
                '<p class="title">DIRETOR DE CADASTRO E REG. PROFISSIONAL</p> ' +
                '<p class="sub">CRDD-PR</p> ' +
            '</div> ' +
        '</div> ' +
    '</div> ' +
'</body> ' +
'</html>'
    );
}
